import { createSlice } from '@reduxjs/toolkit';
import { CLIENT_TYPES } from 'src/constants';
import {
  GetAppConfigs,
  GetAppDefinations,
  GetCustomNetworkList,
  GetReportConfigs,
} from './api-calls/configCalls';

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    isLogin: false,
    isContentLoader: false,
    loadingNum: 0,
    loginUser: {},
    portalType: 'admin',
    //isMobileClient: false,
    is404Error: false,
    loadingProgress: 0,
    appConfigs: {},
    reportConfig: {},
    appDefinations: {},
    customNetwork: {},
    clientType: CLIENT_TYPES.WEB, //'web | tablet | mobile'
  },
  reducers: {
    setIsLogin: (state) => {
      state.isLogin = true;
    },
    setUser: (state, payload) => {
      state.loginUser = payload;
    },
    unSetLogin: (state) => {
      state.isLogin = false;
      state.loginUser = {};
      state.appConfigs = {};
      state.appDefinations = {};
      state.customNetwork = {};
      state.reportConfig = {};
    },
    setContentLoader: (state, action) => {
      state.isContentLoader = true;
      state.loadingNum =
        typeof action.payload === 'number'
          ? action.payload
          : state.loadingNum + 1;
    },
    unSetContentLoader: (state) => {
      state.loadingNum = state.loadingNum > 0 ? state.loadingNum - 1 : 0;
      state.isContentLoader = false;
    },
    setRedirectOnError: (state, action) => {
      state.redirectOnError = action.payload || false;
    },
    setIsTokenExpired: (state, action) => {
      state.isTokenExpired = action.payload || false;
    },
    setPortalType: (state, action) => {
      state.portalType = action.payload;
      //state.redirectedDueToError = true
    },
    setClientType: (state, action) => {
      state.clientType = action.payload;
    },
    setIs404Error: (state, action) => {
      state.is404Error = action.payload;
    },
    setLoadingProgress: (state, action) => {
      state.loadingProgress = action.payload;
    },
    setAppConfig: (state, action) => {
      state.appConfigs = action.payload;
    },
    setReportConfig: (state, action) => {
      state.reportConfig = action.payload;
    },
  },
  extraReducers: {
    [GetAppConfigs.pending]: (state, action) => {
      state.appConfigs = {};
    },
    [GetAppConfigs.fulfilled]: (state, action) => {
      const response =
        action?.payload?.Response?.Clientconfiguration?.configuration;
      state.appConfigs = response || '';
    },
    [GetAppConfigs.rejected]: (state, action) => {
      state.appConfigs = {};
    },
    [GetAppDefinations.pending]: (state, action) => {
      state.appDefinations = {};
    },
    [GetAppDefinations.fulfilled]: (state, action) => {
      const response =
        action?.payload?.Response?.Clientconfiguration?.configuration;
      state.appDefinations = response || '';
    },
    [GetAppDefinations.rejected]: (state, action) => {
      state.appDefinations = {};
    },
    [GetCustomNetworkList.pending]: (state, action) => {
      state.customNetwork = {};
    },
    [GetCustomNetworkList.fulfilled]: (state, action) => {
      const response =
        action?.payload?.Response?.Clientconfiguration?.configuration;
      state.customNetwork = response || '';
    },
    [GetCustomNetworkList.rejected]: (state, action) => {
      state.customNetwork = {};
    },
    [GetReportConfigs.pending]: (state, action) => {
      state.reportConfig = {};
    },
    [GetReportConfigs.fulfilled]: (state, action) => {
      const response =
        action?.payload?.Response?.Clientconfiguration?.configuration;
      state.reportConfig = response || '';
    },
    [GetReportConfigs.rejected]: (state, action) => {
      state.reportConfig = {};
    },
  },
});

//Action creators are generated for each case reducer function
export const {
  setIsLogin,
  setUser,
  unSetLogin,
  setContentLoader,
  unSetContentLoader,
  setRedirectOnError,
  setPortalType,
  showAdminBreadcum,
  hideAdminBreadcum,
  setClientType,
  setIs404Error,
  setLoadingProgress,
  setIsTokenExpired,
  setAppConfig,
  setReportConfig,
} = appSlice.actions;

export default appSlice.reducer;
